module.exports = __webpack_public_path__ + "img/vectrait_logo.614a84fd.svg";